export const BANNER_KEY = "valiosia_pwa_banner_dismissed";
export const INSTALLED_KEY = "valiosia_pwa_installed_tracked";
export const PUSH_ASKED_KEY = "pwa_push_sheet_seen";

const BANNER_PATHS = new Set([
  "/dashboard", "/marca", "/library", "/calendario", "/perfil", "/avatars", "/admin",
]);

export function isPwaBannerRoute(path = "") {
  const p = String(path).split("?")[0];
  if (BANNER_PATHS.has(p)) return true;
  if (p.startsWith("/admin/")) return true;
  return false;
}
export const DISMISS_MS = 14 * 24 * 60 * 60 * 1000;

export function isStandalone(win = typeof window === "undefined" ? undefined : window) {
  if (!win) return false;
  const mm = typeof win.matchMedia === "function" && win.matchMedia("(display-mode: standalone)").matches;
  return Boolean(mm || win.navigator?.standalone);
}

export function isIos(win = typeof window === "undefined" ? undefined : window) {
  if (!win?.navigator) return false;
  return /iphone|ipad|ipod/i.test(win.navigator.userAgent);
}

export function canNativeInstall(deferred) {
  return Boolean(deferred && typeof deferred.prompt === "function");
}

export function isBannerDismissed(now = Date.now(), storage = typeof localStorage === "undefined" ? null : localStorage) {
  if (!storage) return false;
  try {
    const raw = storage.getItem(BANNER_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return false;
    return now - ts < DISMISS_MS;
  } catch {
    return false;
  }
}

export function dismissBanner(now = Date.now(), storage = typeof localStorage === "undefined" ? null : localStorage) {
  try { storage?.setItem(BANNER_KEY, String(now)); } catch { /* private mode */ }
}

export function shouldShowBanner({ standalone, dismissed, allowed, onAppSurface }) {
  return Boolean(allowed && onAppSurface && !standalone && !dismissed);
}

export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}
